import { all, call, put, takeLatest, fork } from "redux-saga/effects";
import actions from "./actions";
import { teamSettingsService } from "@iso/services";

export function* getTeamSettings() {
  yield takeLatest(actions.GET_TEAM_SETTINGS_REQUEST, function* ({ payload }) {
    const { resolve, reject } = payload || {};
    try {
      const response = yield call(teamSettingsService.getList);
      yield put({
        type: actions.GET_TEAM_SETTINGS_SUCCESS,
        list: response || [],
      });
      if (resolve) resolve(response);
    } catch (error) {
      yield put({
        type: actions.GET_TEAM_SETTINGS_ERROR,
        error: error,
      });
      if (reject) reject(error);
    }
  });
}

export function* upsertTeamSetting() {
  yield takeLatest(actions.UPSERT_TEAM_SETTING_REQUEST, function* ({ payload }) {
    const { data, resolve, reject } = payload || {};
    try {
      const response = yield call(teamSettingsService.upsert, data);
      yield put({
        type: actions.UPSERT_TEAM_SETTING_SUCCESS,
      });
      if (resolve) resolve(response);
    } catch (error) {
      yield put({
        type: actions.UPSERT_TEAM_SETTING_ERROR,
        error: error,
      });
      if (reject) reject(error);
    }
  });
}

export function* toggleSync() {
  yield takeLatest(actions.TOGGLE_SYNC_REQUEST, function* ({ payload }) {
    const { id, data, resolve, reject } = payload || {};
    try {
      const response = yield call(teamSettingsService.toggleSync, id, data);
      yield put({
        type: actions.TOGGLE_SYNC_SUCCESS,
      });
      if (resolve) resolve(response);
    } catch (error) {
      yield put({
        type: actions.TOGGLE_SYNC_ERROR,
        error: error,
      });
      if (reject) reject(error);
    }
  });
}

export function* deleteSetting() {
  yield takeLatest(actions.DELETE_SETTING_REQUEST, function* ({ payload }) {
    const { id, resolve, reject } = payload || {};
    try {
      const response = yield call(teamSettingsService.deleteSettings, id);
      yield put({
        type: actions.DELETE_SETTING_SUCCESS,
      });
      if (resolve) resolve(response);
    } catch (error) {
      yield put({
        type: actions.DELETE_SETTING_ERROR,
        error: error,
      });
      if (reject) reject(error);
    }
  });
}

export function* clearSetting() {
  yield takeLatest(actions.CLEAR_SETTING_REQUEST, function* ({ payload }) {
    const { id, resolve, reject } = payload || {};
    try {
      const response = yield call(teamSettingsService.clearSettings, id);
      yield put({
        type: actions.CLEAR_SETTING_SUCCESS,
      });
      if (resolve) resolve(response);
    } catch (error) {
      yield put({
        type: actions.CLEAR_SETTING_ERROR,
        error: error,
      });
      if (reject) reject(error);
    }
  });
}

export function* bulkSync() {
  yield takeLatest(actions.BULK_SYNC_REQUEST, function* ({ payload }) {
    const { id, data, resolve, reject } = payload || {};
    try {
      const response = yield call(teamSettingsService.bulkSync, id, data);
      yield put({
        type: actions.BULK_SYNC_SUCCESS,
      });
      if (resolve) resolve(response);
    } catch (error) {
      yield put({
        type: actions.BULK_SYNC_ERROR,
        error: error,
      });
      if (reject) reject(error);
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getTeamSettings),
    fork(upsertTeamSetting),
    fork(toggleSync),
    fork(clearSetting),
    fork(deleteSetting),
    fork(bulkSync),
  ]);
}
